import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Drawer, MultiSelectChips } from '@saas-kit/ui';

import type { QmsCounter, QmsService } from './types';

export function CounterServicesDrawer({
  counter,
  services,
  saving,
  onClose,
  onSave,
}: {
  counter: QmsCounter | null;
  services: QmsService[];
  saving: boolean;
  onClose: () => void;
  onSave: (counterId: string, serviceIds: string[]) => void;
}): JSX.Element {
  const { t } = useTranslation('qms');
  const [serviceIds, setServiceIds] = useState<string[]>([]);

  useEffect(() => {
    setServiceIds(counter?.service_ids ?? []);
  }, [counter]);

  return (
    <Drawer
      open={counter !== null}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title={t('fields.services')}
      footer={
        counter ? (
          <Button
            disabled={saving}
            onClick={() => onSave(counter.id, serviceIds)}
          >
            {t('actions.save')}
          </Button>
        ) : null
      }
    >
      <MultiSelectChips
        options={services.map((s) => ({ value: s.id, label: s.name }))}
        value={serviceIds}
        onChange={setServiceIds}
        selectAllLabel={t('actions.select_all')}
        clearLabel={t('actions.clear_all')}
      />
    </Drawer>
  );
}
